import AScene from '../../library/ExtendedObjects/AScene.js';
import gameData from '../../gameData.js';
import Fuzzbug from '../Fuzzbug.js';

export default class Intro extends AScene {
  static get KEY() { return 'Intro'; }

  create() {
    gameData.currentScene = 'Intro';
    gameData.gameOver = false;
    gameData.gamePaused = false;
    gameData.customizerComplete = false;
    gameData.score = 0;
    gameData.counter = 0;
    gameData.level = 0;
    gameData.fuzzIndex = 0;

    gameData.fuzzStencil = '',
    gameData.fuzzStencil_Color = '',
    gameData.fuzzStencil_Name = '',
    gameData.fuzzColor = '',
    gameData.fuzzColor_Name = '',
    gameData.customFuzzbug = false,
    gameData.customReplacementID = 1,
    gameData.customReplacementColor = '',

    this.playJingle();

    this.createIntro();
  }

  playJingle() {
    let counter = 0;

    // console.log(this.sound.sounds);
    for (let i = 0; i < this.sound.sounds.length; i++) {
      // console.log(this.sound.sounds[i].currentMarker.name);
      if (this.sound.sounds.length > 0 && this.sound.sounds[i].currentMarker && this.sound.sounds[i].currentMarker.name === 'jingle_patterns') counter++;
    }
    if (counter === 0) gameData.jingle = this.playSound('jingle_patterns', .2, true);
  }

  createIntro() {
    this.bg = this.addImage(this.mid.x, this.mid.y, 'Bckg');

    this.title = this.addImage(this.mid.x, -200, 'Logo_Fuzz_Bugs');

    this.playBtn = this.addButton(this.mid.x + 390, 278, 'Btn_Play', {}, () => {this.tweenOutIntro();});
    this.playBtn.setEnabled(false);
    this.playBtn.setAlpha(0);

    this.playSound('title_tweens', .5);

    this.fb = new Fuzzbug(this, -300, this.mid.y + 355, 1, 'RunningRight');

    this.addTween(this.title, 2000, { y: 260 }, Phaser.Math.Easing.Back.Out);
    this.addTween(
      this.playBtn,
      1000,
      { alpha: 1, delay: 1500 },
      Phaser.Math.Easing.None,
      () => {this.playBtn.setEnabled(true);}
    );
  }

  tweenOutIntro() {
    this.playBtn.setEnabled(false);

    this.fb.leaveGame();

    this.playSound('click');

    this.addTween(
      this.title,
      1500,
      { y: -200 },
      Phaser.Math.Easing.Back.In,
      () => {this.cleanUp();}
    );
    this.addTween(this.playBtn, 1500, { alpha: 0 }, Phaser.Math.Easing.None);
  }

  cleanUp() {
    // console.log("going to game");

    this.fb.cleanUp();
    this.fb.destroy();
    this.fb = null;

    this.title.destroy();
    this.playBtn.destroy();

    this.scene.start('Game');
  }
}